import { CONFIRMATION_MODE, CONFIRMATION_RESULT, VALUE_ESCAPE, WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import { ConfirmationResultObj, IWizRoute, WizActionObj, WizBasePopUp, WizDatasource, WizDropdown, WizEvent, WizEventManager, WizNavigationManager, WizPopUp, WizRoot, WizTabBar, WizTabButton } from '@wizeoo/akm-component-lib';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ALK_EVENT_TYPE, UserApplicationVO, UserContextService, ViewData } from '@wizeoo/akm-common-lib';
import { StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { VisionVO } from '@wizeoo/akm-compute-lib';
import { Model } from 'src/app/model/model';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { distinctUntilChanged, filter, map, Subject, takeUntil } from 'rxjs';
import { ActivationEnd, Router } from '@angular/router';
import { TabVO } from '@wizeoo/akm-common-lib';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'menu-popup',
  templateUrl: './menu.pop.html',
})
export class MenuPopUp extends WizBasePopUp {

  @ViewChild('ddVision', { read: WizDropdown }) ddVision: WizDropdown;
  /** Tab bar */
  @ViewChild('tabBar', { read: WizTabBar, static: true }) tabBar: WizTabBar;

  // visible si mode "wzb"
  public get webMode():boolean {
    return Model.getInstance()?.currentVision?.navigationMode === ViewData.NAVIGATION_WEB;
  }



  public static baseWidth: string = '300px';
  public static maxWidth: string = '700px'; // pour override de prise de taille sur construction. Sera accessible depuis la factory
  public static requestHeight: string = 'calc(100% - 40px)';// '500px'; 
  public static smallHeight: string = '70px';

  public static getWidth(): string {
    // if(Model.getInstance().allVision?.length > 0) {
    //   return this.maxWidth;
    // }
    // else {
      return this.baseWidth;
    //}
  }

  public static getHeight(): string {
    if(Model.getInstance()?.currentVision?.navigationMode === ViewData.NAVIGATION_WEB) {
      return this.requestHeight;
    } else {
      return this.smallHeight;
    }
    
  }

  // public get hasVisions(): boolean {
  //   return Model.getInstance().allVision?.length > 0;
  // }


  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === VALUE_ESCAPE) {
      this.hide();
    }
  }

  constructor(public elementRef: ElementRef, private router: Router) {
    super();
  }

  public show(): void {

    // this.visionDS.setSource(Model.getInstance().allVision);

    this.visionSource.setSource(Model.getInstance().visionEngine.visionDS.getSource()) ; 
    this.setVision();

    this.initTabs();


    // écoute en mode capture sur le changing, pour affichage éventuelle de popUp cancel si modif
    WizEventManager.addListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.checkVisionChange, {
      capture: true,
    });
    // application du changement de vision par la dropdown
    WizEventManager.addListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.updateVision);


    WizEventManager.addListener(this, this.tabBar, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.clicOnTab, {
      capture: true,
    }); // écoute sélection d'un onglet

    // Ecoute des modifications depuis la vue de configuration des tabs (newtabView)
    //WizEventManager.addListener(this, this.tabBar, ALK_EVENT_TYPE.TAB_COLLECTION_CHANGE, this.onTabRefresh ); // écouteur global sur le changement de vision

  }

  public onHide(): void {
        // écoute en mode capture sur le changing, pour affichage éventuelle de popUp cancel si modif
    WizEventManager.removeListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    // application du changement de vision par la dropdown
    WizEventManager.removeListener(this, this.ddVision, WIZ_EVENT_TYPE.SELECTION_CHANGED);
    WizEventManager.removeListener(this, this.tabBar, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    //WizEventManager.removeListener(this, this.tabBar, ALK_EVENT_TYPE.TAB_COLLECTION_CHANGE);
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }

  // visionDS: WizDatasource<VisionVO> = new WizDatasource<VisionVO>([])
  //   .setSortFields([
  //     { property: 'domain', way: 'asc' },
  //     { property: 'businessUnitCode', way: 'asc' },
  //     { property: 'trsLabel', way: 'asc' },
  //   ])
  //   .setFilter(this.filterVision.bind(this))
  //   .build();

  /** Affichage des Apps */
  // public visionMDConfig: MultiDisplayConfig<VisionVO> = {
  //   model: Model.getInstance(),
  //   datasource: this.visionDS,
  //   defaultMode: 'grid',
  //   onSelectionChanged: this.onVisionChanged.bind(this),
  //   grid: {
  //     enabled: true,
  //     columns: [
  //       {
  //         headerName: '$.common.domain.$',
  //         field: 'domain',
  //         width: 150,
  //         sortable: true,
  //         tooltipField: 'domain',
  //         cellRenderer: 'domIconRenderer'
  //       },
  //       {
  //         headerName: '$.common.bu.$',
  //         field: 'businessUnitCode',
  //         width: 150,
  //         sortable: true,
  //         tooltipField: 'businessUnitCode',
  //         cellRenderer: 'buIconRenderer'
  //       },
  //       {
  //         headerName: '$.common.vision.$',
  //         field: 'code',
  //         width: 220,
  //         sortable: true,
  //         tooltipField: 'code',
  //         cellRenderer: 'visionIconRenderer'
  //       },
  //       {
  //         headerName: '$.common.label.$',
  //         field: 'trsLabel',
  //         width: 150,
  //         sortable: true,
  //         tooltipField: 'trsLabel'
  //       },
  //       {
  //         headerName: '$.common.description.$',
  //         field: 'trsDescription',
  //         minWidth: 300,
  //         flex: 1,
  //         sortable: true,
  //         tooltipField: 'trsDescription'
  //       }
  //     ],
  //     renderers: { buIconRenderer: BuIconRenderer, domIconRenderer: DomIconRenderer, visionIconRenderer: VisionIconRenderer }
  //   },
  //   filter: {
  //     enabled: true,
  //     initFilter: this.initAppFilter.bind(this),
  //   },
  // };

  // appFilter: FilterComponent;


/**
   * Initialisation du filtre des visions
   * @param pFilter Le composant de filtre à initialiser
   * @returns
   */
//  initAppFilter(pFilter: FilterComponent): FilterComponent {
//   this.appFilter = pFilter;

//   this.appFilter.configure(['domain', 'businessUnitCode', 'code', 'trsLabel'], null, null);
//   return this.appFilter.build();
// }

/**
 * Filtre des visions
 * @param item La vision à filtrer
 * @returns True si la vision doit être visible
 */
// filterVision(item: VisionVO): boolean {
  
//   if (!this.appFilter) {
//     return false;
//   }
  
//   // Si le user n'a pas le rôle vision_access, on filtre
//   if (!this.appFilter.checkVisible(item)) {
//     return false;
//   }
//   const perimeter: UserApplicationVO = Model.getInstance().userAppEngine.newUserApp(item.domain, item.businessUnitCode, item.code);
//   if (Model.getInstance().permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, perimeter)) {
//     return true;
//   }

//   return false;
// }

  private onceIsGood: boolean = false; // LMA bug double passage
 
 
  visionSource: WizDatasource<VisionVO> = new WizDatasource<VisionVO>()
    .setSortFields([{ property: 'code', way: 'asc' }])
    .setFilter(this.filterVisionDD.bind(this))
    .setSelectionMode('single')
    .build();

 
  /**
   * jump
   */
  // onVisionChanged(event: WizEvent) {
  //   if (!this.onceIsGood) {
  //     this.onceIsGood = true;
  //     const vision: VisionVO = this.visionDS.selectedItem;

  //     let res: string =  window.location.protocol+ '//';
  //     const urlParts: string[] = window.location.hostname.split('.'); // on split les morceaux
  //     urlParts[0]=vision.domain.toLowerCase(); // on prend le domain
  //     res+=urlParts.join('.');
  //     res += EnvironnementManager.envConfig.allkeyMeSuffix;
  //     const url: URL = new URL(res);
  //     // url.searchParams.set('domain', vision.domain);
  //     url.searchParams.set('bu', vision.businessUnitCode);
  //     url.searchParams.set('vision', vision.code);
  //     window.open(url.toString(), '_blank').focus();
  //     this.hide();
  //   }
  // }

  /**
   * changing en mode capture sur la drop
   * @param e 
   */
  private checkVisionChange(e: WizEvent): void {
    if (ViewData.wizUpdateModel) {
      e.preventDefault();
      // True : le modèle à changé
      // ouverture de la popup
      // l'event est passé en params
      WizPopUp.confirm(
        '$.cancel.update.pop.title.$',
        '$.cancel.update.pop.content.$',
        this.popupConfirmationCallback.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        e
      ).show();
    } else {
    }
  }

  /**
   * Callback de la  WizPopupConfirmation
   * @param confirmationResult : retour normé sur pop de validation de navigation
   */
  private popupConfirmationCallback(confirmationResult: ConfirmationResultObj) {
    if (confirmationResult.result === CONFIRMATION_RESULT.CONFIRM) {
      WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
      this.updateVision(confirmationResult.data);
    }
  }

  /**
   * application du changement de vision depuis la drop
   * @param e 
   */
  private updateVision(e: WizEvent): void {
    const nextVision: VisionVO = e.value[0];
    if (!!nextVision && nextVision.code !== Model.getInstance().visionCode) { // seulement si réel changement
      // le setter du modèle va dispatcher un event ALK_EVENT_TYPE.SELECT_VISION     
      Model.getInstance().visionEngine.selectVision(nextVision ? nextVision.code : ViewData.defaultVision);
      // Model.getInstance().navigationEngine.updateUrlContext(true); // mise à jour de l'URL
    }
    this.hide();
  }

  /** visible si + d'une vision */
  public get moreThanOnce(): boolean {
    let result: boolean = false;
      
    // if (Model.getInstance().domainCode && Model.getInstance().businessUnitCode) {
    //   const userApp = Model.getInstance().userEngine.getUserApp(Model.getInstance().connectedUser, Model.getInstance().domainCode, Model.getInstance().businessUnitCode);
    //   if (!!userApp) {
    //     result = Model.getInstance().permissionEngine.canAccessPerimeter(userApp)
    //   }
    // }

    // console.log('userApp', this.visionSource);
    if (this.visionSource && this.visionSource.getWorkedSource().length > 1 ) {
      result = true;
    }

    return result;
  }

  /**
   * synchro de la DS de la dropdown des visions et sélection de la vision active
   * @param e 
   */
  private setVision(): void {  
    const realVision: VisionVO = Model.getInstance().currentVision;
    this.visionSource.select([realVision]);
  }

  /**
   * filtre sur la DS des visions dans la drop, selon les droits du user (et si même BU)
   * @param vision 
   * @returns 
   */
  private filterVisionDD(vision: VisionVO): boolean {
      const sameBu: boolean = vision.businessUnitCode === Model.getInstance().businessUnitCode;
      const perm: boolean = Model.getInstance().permissionEngine.canRead(vision.code);
      
      let perim: boolean = false;
      const perimeter: UserApplicationVO = Model.getInstance().userAppEngine.newUserApp(vision.domain, vision.businessUnitCode, vision.code);
      if (Model.getInstance().permissionEngine.canRead(StaticFeatureEnum.VISION_ACCESS, perimeter)) {
        perim = true;
      }
      return sameBu && perim;
  }

  public tabs: WizDatasource<WizActionObj> = new WizDatasource<WizActionObj>().build(); // la DS de la Tabbar
  private _destroyed$: Subject<boolean> = new Subject<boolean>();
    /**
     * Le chemin sur lequel on se trouve
     */
    private _currentTab: string;


  /** chargement des tabs du user sur origine / changement */
  private drawTabs(): void {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    this.tabs.setSortField({ property: 'order', way: 'asc', numeric: true });
    this.tabs.setSource(Model.getInstance().tabEngine.refreshTabs(!!currV && currV.code === RouteEngine.VISION_VIEW).getSource());
    
    // this.tabs.refresh();
    // this.tabs.getWorkedSource().forEach(wao => {
    //   // arrMap.set(wao.buttonCode, wao);
    //   console.log('draw',wao.buttonCode, wao.order);
    // });
    // console.log('tabbar draw tabs', this.tabs);
    // Sur un changement manuel d'ordre des tabs, on update le context avec la nouvelle collection
    this.tabs.changes
      .pipe(
        filter(({ type }) => type === 'orderChanged'),
        takeUntil(this._destroyed$)
      )
      .subscribe(({ value }) => {
        // let tatabs = this.tabs;
        let idx:number = 1;
        let arr: WizActionObj[] = [];
        //tatabs.getWorkedSource()
        value.forEach((wao: WizActionObj) =>{
          wao.order = idx;
          arr.push(wao);
          idx++;
          // console.log(wao.buttonCode, wao.order);
        });

        
        // let arrMap: Map<string, WizActionObj> = new Map();
        // // Fix valeurs en double...
        // arr.forEach(wao => {
        //   arrMap.set(wao.buttonCode, wao);
        //   // console.log(wao.buttonCode, wao.order);
        // });
        // let cleanArr = [...arrMap.values()];
        // arr.forEach(wao => {
        //   // arrMap.set(wao.buttonCode, wao);
        //   console.log(wao.buttonCode, wao.order);
        // });
        Model.getInstance().tabEngine.updateContextTabs(arr);
        //this.tabs.refresh();
      });
  }

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }

  private _onTabChanged(pTabCode: string, pCommit: boolean = true) {
    const wao: WizActionObj = this.tabs.find((v) => v.featureCode === pTabCode || v.buttonCode === pTabCode);
    this._currentTab = pTabCode;
    if (!!wao) {
      this.tabs.select([wao]);
      // TabEngine.currentTab = wao;
      ViewData.currentTab = wao;

    } else {
      // gestion du cas ou la nouvelle vue est une tab disponible mais ne fait pas partie du contexte
      const newWao: WizActionObj = Model.getInstance().tabEngine.availableTabs.find(
        (tab) => tab.featureCode === pTabCode || tab.buttonCode === pTabCode
      );
      if (
        newWao &&
        Model.getInstance().tabEngine.currentTabs.find(({ buttonCode }) => buttonCode === newWao.buttonCode) === undefined
      ) {
        let selection: WizActionObj[] = Model.getInstance().tabEngine.currentTabs.getWorkedSource();
        selection = selection.concat(newWao);
        Model.getInstance().tabEngine.updateContextTabs(selection);

        this.tabs.select([this.tabs.find((t) => t.buttonCode === newWao.buttonCode)]);
        // TabEngine.currentTab = newWao;
        ViewData.currentTab = newWao;
      } else {
        this.tabs.clearSelection();
      }
    }

    if (pCommit) {
      // this._context.saveCurrentVision({ data: {selectedTab: TabEngine.currentTab?.featureCode }});
      this._context.saveCurrentVision({ data: {selectedTab: ViewData.currentTab?.featureCode }});
    }
  }

  private initTabs(): void {
    this.drawTabs();
    // Initialisation du selectedTab selon les données du contexte utilisateur
    this._onTabChanged(this._context.getCurrentTab()?.selectedTab, false);

    this.router.events
      .pipe(
        filter((event) => event instanceof ActivationEnd),
        map((event: ActivationEnd) => ({ event, wizroute: event.snapshot.routeConfig as IWizRoute })),
        filter(({ event, wizroute }) => {
          return !!event.snapshot.params?.code || !!wizroute?.featureCode || !!wizroute?.fullPath;
        }),
        map(({ event, wizroute }) => event.snapshot.params.code || wizroute.featureCode || wizroute.fullPath),
        distinctUntilChanged(),
        filter((tabCode) => tabCode !== this._context.getCurrentTab()?.selectedTab),
        takeUntil(this._destroyed$)
      )
      .subscribe((tab) => this._onTabChanged(tab));
  }

  /**
   * Clic sur un onglet
   * @param e evenement clic
   */
  public clicOnTab(e: WizEvent) {
    e.preventDefault();
    const navigationButton: WizTabButton = e.value ? (e.value.next as WizTabButton) : null;
    if (!!navigationButton) {
      this.doNavigate(navigationButton.data);
    }
  }

  /**
   * Déclenche la navigation suivant le paramétrage de l'action obj en param
   * @param tab
   */
  private doNavigate(tab: WizActionObj) {
    if (tab.kind === ViewData.KIND_DYNAMIC) {
      const tabData: TabVO = tab.data;
      Model.getInstance().navigationEngine.navigate([RouteEngine.USER_TAB_VIEW, tabData.code]);
    } else if (WizNavigationManager.getPathRoute(tab.buttonCode)) {
      Model.getInstance().navigationEngine.navigate(tab.buttonCode);
    }
    this.hide();
  }

  public showTabView(): void {
    Model.getInstance().navigationEngine.navigate(RouteEngine.NEWTAB_VIEW);
    this.hide();
  }


}
